import InstallCoreTabs from "common/core/install/install";
import JwtGenerateSnippet from "snippets/core/jwt-generate";
import * as React from 'react';
export default {
  InstallCoreTabs,
  JwtGenerateSnippet,
  React
};